import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Loader } from "../components/CustomLoader";
import ThemePreview from "../components/ThemePreview";
import { hasPermission, getFirstAvailableRoute } from "../utils/helpers";
import Category from "../pages/Category";
import AddEditCategory from "../pages/Category/AddEdit";
import AddEditSubCategory from "../pages/Category/AddEditSubCategory";
import ViewSubLastCategory from "../pages/Category/ViewSubLastCategory";
import CategoryView from "../pages/Category/view";

const MyAccount = lazy(() => import("../pages/myAccount/MyAccount"));
const GlobalSetting = lazy(() => import("../pages/Global Setting"));
const PrivateLayout = lazy(() => import("../layouts/private"));
const Page404 = lazy(() => import("../pages/error/Page404"));
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));

// users
const UsersList = lazy(() => import("../pages/user/List"));
const UsersView = lazy(() => import("../pages/user/View"));
const UsersAdd = lazy(() => import("../pages/user/Add"));
const UsersEdit = lazy(() => import("../pages/user/Edit"));
const AddpetUser = lazy(() => import("../pages/user/AddPetuser"));
const UpdatePetuser = lazy(() => import("../pages/user/UpdatePetuser"));

const SubscriptionList = lazy(() => import("../pages/subscription/List"));
const SubscriptionView = lazy(() => import("../pages/subscription/View"));
const SubscriptionEdit = lazy(() => import("../pages/subscription/Edit"));
const PetsitterplanEdit = lazy(
  () => import("../pages/subscription/PetsitterplanEdit"),
);
const UserplanEdit = lazy(() => import("../pages/subscription/userplansedit"));

//subadmin
const SubAdminList = lazy(() => import("../pages/subadmin/List"));
const SubAdminAdd = lazy(() => import("../pages/subadmin/Add"));
const SubAdminView = lazy(() => import("../pages/subadmin/View"));

//subadmin roles
const RoleList = lazy(() => import("../pages/subadmin/roles/List"));
const RoleAdd = lazy(() => import("../pages/subadmin/roles/Add"));
//reviews

const ReviewsList = lazy(() => import("../pages/reviews/List"));

//organizer
const OrganizerListView = lazy(
  () => import("../pages/organizer/allorganizerlist"),
);
const Vieworganizer = lazy(() => import("../pages/organizer/vieworganizer"));
const Addorganizer = lazy(() => import("../pages/organizer/addorganizer"));

//events
const EventListView = lazy(() => import("../pages/event/List"));
const EventView = lazy(() => import("../pages/event/View"));
const EventEdit = lazy(() => import("../pages/event/Edit"));
const EventAdd = lazy(() => import("../pages/event/Add"));

//org services
const OrgServiceAddEdit = lazy(() => import("../pages/orgservices/AddEdit"));
const OrgServiceList = lazy(() => import("../pages/orgservices/List"));
const OrgServiceView = lazy(() => import("../pages/orgservices/View"));

//vendor
const VendorList = lazy(() => import("../pages/vendor/List"));
const VendorView = lazy(() => import("../pages/vendor/View"));
const VendorEdit = lazy(() => import("../pages/vendor/Edit"));
const VendorAdd = lazy(() => import("../pages/vendor/Add"));

//petsitter
const PetsitterList = lazy(() => import("../pages/petsitter/List"));
const PetsitterAddEdit = lazy(() => import("../pages/petsitter/AddEdit"));
const PetsitterView = lazy(() => import("../pages/petsitter/View"));
const PetsitterServicesList = lazy(
  () => import("../pages/petsitter/ServicesList"),
);
const PetsitterAllServicesList = lazy(
  () => import("../pages/petsitter/AllServicesList"),
);
const PetsitterServicesView = lazy(
  () => import("../pages/petsitter/ServicesView"),
);
const PetsitterServicesAddEdit = lazy(
  () => import("../pages/petsitter/ServicesAddEdit"),
);
// product

const ProductList = lazy(() => import("../pages/product/List"));
const ProductView = lazy(() => import("../pages/product/View"));
const ProductEdit = lazy(() => import("../pages/product/Edit"));

// ads

const AdsList = lazy(() => import("../pages/ads/List"));
const AdsView = lazy(() => import("../pages/ads/View"));
const AdsAddEdit = lazy(() => import("../pages/ads/AddEdit"));

// cms -> faq management
const FaqList = lazy(() => import("../pages/cms/FaqManagement/List"));
const Faqview = lazy(() => import("../pages/cms/FaqManagement/view"));
const FaqAdd = lazy(() => import("../pages/cms/FaqManagement/Add"));
const FaqEdit = lazy(() => import("../pages/cms/FaqManagement/Edit"));

// cms -> about us management
const AbtEdit = lazy(() => import("../pages/cms/aboutus/Edit"));
const AbtView = lazy(() => import("../pages/cms/aboutus/View"));

// cms -> Community
const CommEdit = lazy(() => import("../pages/cms/community/Edit"));
const CommView = lazy(() => import("../pages/cms/community/View"));

// cms -> privacypolicy
const PrivacypolicyEdit = lazy(() => import("../pages/cms/privacypolicy/Edit"));
const PrivacypolicyView = lazy(() => import("../pages/cms/privacypolicy/View"));
const PrivacypolicyList = lazy(() => import("../pages/cms/privacypolicy/List"));

//pet spots
const PetSpotsList = lazy(() => import("../pages/petspots/List"));
const PetSpotsAddEdit = lazy(() => import("../pages/petspots/AddEdit"));
const PetSpotsView = lazy(() => import("../pages/petspots/View"));
// pet quiz
const PetQuizList = lazy(() => import("../pages/petquiz/List"));
const PetQuizAddEdit = lazy(() => import("../pages/petquiz/AddEdit"));

// cms -> EventGuidelins

const EventGuidelinsEDIT = lazy(
  () => import("../pages/cms/eventguidelines/Edit"),
);
const EventGuidelinsView = lazy(
  () => import("../pages/cms/eventguidelines/View"),
);

// cms -> refundpolicies

const RefundpoliciesList = lazy(
  () => import("../pages/cms/refundpolicies/List"),
);
const RefundpoliciesEDIT = lazy(
  () => import("../pages/cms/refundpolicies/Edit"),
);
const RefundpoliciesView = lazy(
  () => import("../pages/cms/refundpolicies/View"),
);

// cms -> Notification Templates
const NotificationTemplateList = lazy(
  () => import("../pages/cms/NotificationTemplates/List"),
);
const NotificationTemplateView = lazy(
  () => import("../pages/cms/NotificationTemplates/View"),
);
const NotificationTemplateAddEdit = lazy(
  () => import("../pages/cms/NotificationTemplates/AddEdit"),
);
const CmsOtherList = lazy(() => import("../pages/cms/other/List"));
const CmsOtherAddEdit = lazy(() => import("../pages/cms/other/AddEdit"));
const CmsOtherView = lazy(() => import("../pages/cms/other/View"));
const LandingPageManage = lazy(() => import("../pages/landing-page/Manage"));

// cms -> TermsCondition
const TermsConditionList = lazy(
  () => import("../pages/cms/termsconditions/List"),
);
const TermsConditionEdit = lazy(
  () => import("../pages/cms/termsconditions/Edit"),
);
const TermsConditionView = lazy(
  () => import("../pages/cms/termsconditions/View"),
);

const PaymentpayoutList = lazy(() => import("../pages/paymentpayout/List"));

//userreport
const Userreportlist = lazy(() => import("../pages/UserReport/List"));

//usersupportfeedback
const Usersupportfeedbacklist = lazy(
  () => import("../pages/usersupportfeedback/List"),
);

//global
const GlobalAll = lazy(() => import("../pages/global/All"));

//marketing
const MarketingManagement = lazy(() => import("../pages/marketing/List"));

//reports
const ReportsAnalytics = lazy(() => import("../pages/reports/List"));

const LoadingFallback = (
  <div>
    <Loader />
  </div>
);

const makeLazyComponent = (importFunc) => (
  <Suspense fallback={LoadingFallback}>{importFunc()}</Suspense>
);

const MainRouting = ({ permissions }) => {
  const userFromRedux = useSelector((state) => state?.auth?.user);
  let user = userFromRedux;
  if (!user) {
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) user = JSON.parse(storedUser);
    } catch (e) {
      user = null;
    }
  }

  const routes = [
    {
      element: <PrivateLayout />,
      errorElement: <Page404 />,
      children: [
        {
          element: (
            <Navigate to={getFirstAvailableRoute(user) || "/dashboard"} />
          ),
          index: true,
        },
        {
          path: "dashboard",
          element: makeLazyComponent(() => <DashboardPage />),
        },
        {
          path: "theme-preview",
          element: <ThemePreview />,
        },
        {
          path: "profile",
          element: makeLazyComponent(() => <MyAccount />),
        },
        {
          path: "global-setting",
          element: makeLazyComponent(() => <GlobalSetting />),
        },
        ...(hasPermission("User Management", user)
          ? [
            {
              path: "users",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <UsersList />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <UsersAdd />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <UsersView />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <UsersEdit />),
                },
                {
                  path: "adduserpet/:id",
                  element: makeLazyComponent(() => <AddpetUser />),
                },
                {
                  path: "editpetuser",
                  element: makeLazyComponent(() => <UpdatePetuser />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Admin Management", user)
          ? [
            {
              path: "subadmin",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <SubAdminList />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <SubAdminAdd />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <SubAdminView />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <SubAdminAdd />),
                },
                {
                  path: "roles",
                  children: [
                    {
                      index: true,
                      element: makeLazyComponent(() => <RoleList />),
                    },
                    {
                      path: "add",
                      element: makeLazyComponent(() => <RoleAdd />),
                    },
                    {
                      path: "edit/:id",
                      element: makeLazyComponent(() => <RoleAdd />),
                    },
                  ],
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Entities Management", user)
          ? [
            {
              path: "global",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <GlobalAll />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Subscription Management", user)
          ? [
            {
              path: "subscription",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <SubscriptionList />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <SubscriptionView />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <SubscriptionEdit />),
                },
                {
                  path: "petsitterplan/edit/:id",
                  element: makeLazyComponent(() => <PetsitterplanEdit />),
                },
                {
                  path: "userplan/edit/:id",
                  element: makeLazyComponent(() => <UserplanEdit />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Pet Quiz Management", user)
          ? [
            {
              path: "petquiz",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <PetQuizList />),
                },
                {
                  path: "addedit",
                  element: makeLazyComponent(() => <PetQuizAddEdit />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Organizer Management", user)
          ? [
            {
              path: "organizer",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <OrganizerListView />),
                },

                {
                  path: "view",
                  element: makeLazyComponent(() => <Vieworganizer />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <Addorganizer />),
                },

                {
                  path: "add",
                  element: makeLazyComponent(() => <Addorganizer />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Reviews Management", user)
          ? [
            {
              path: "reviews",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <ReviewsList />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Organizer Management", user)
          ? [
            {
              path: "organizerservice",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <OrgServiceList />),
                },

                {
                  path: "view",
                  element: makeLazyComponent(() => <OrgServiceView />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <OrgServiceAddEdit />),
                },

                {
                  path: "add",
                  element: makeLazyComponent(() => <OrgServiceAddEdit />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Organizer Management", user)
          ? [
            {
              path: "event",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <EventListView />),
                },
                {
                  path: ":organizserId",
                  element: makeLazyComponent(() => <EventListView />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <EventAdd />),
                },

                {
                  path: "view",
                  element: makeLazyComponent(() => <EventView />),
                },
                {
                  path: "edit",
                  element: makeLazyComponent(() => <EventEdit />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Payments & Payouts", user)
          ? [
            {
              path: "paymentpayout",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <PaymentpayoutList />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("User Reports", user)
          ? [
            {
              path: "userreport",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <Userreportlist />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Pet Spots Management", user)
          ? [
            {
              path: "petspots",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <PetSpotsList />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <PetSpotsAddEdit />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <PetSpotsAddEdit />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <PetSpotsView />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Support & Feedback", user)
          ? [
            {
              path: "usersupportfeedback",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => (
                    <Usersupportfeedbacklist />
                  )),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Marketing Management", user)
          ? [
            {
              path: "marketing",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <MarketingManagement />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Reports & Analytics", user)
          ? [
            {
              path: "reports",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <ReportsAnalytics />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Vendor Management", user)
          ? [
            {
              path: "vendor",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <VendorList />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <VendorView />),
                },

                {
                  path: "edit",
                  element: makeLazyComponent(() => <VendorEdit />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <VendorAdd />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Petsitter Management", user)
          ? [
            {
              path: "petsitter",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <PetsitterList />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <PetsitterAddEdit />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <PetsitterAddEdit />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <PetsitterView />),
                },
                {
                  path: "all-services",
                  element: makeLazyComponent(() => (
                    <PetsitterAllServicesList />
                  )),
                },
                {
                  path: "services/:id",
                  element: makeLazyComponent(() => <PetsitterServicesList />),
                },
                {
                  path: "services/view/:id",
                  element: makeLazyComponent(() => <PetsitterServicesView />),
                },
                {
                  path: "services/add",
                  element: makeLazyComponent(() => (
                    <PetsitterServicesAddEdit />
                  )),
                },
                {
                  path: "services/edit/:id",
                  element: makeLazyComponent(() => (
                    <PetsitterServicesAddEdit />
                  )),
                },
                // {
                //   path: "services/ads",
                //   element: makeLazyComponent(() => <PetsitterServicesAdsList />),
                // },
                // {
                //   path: "services/ads/view",
                //   element: makeLazyComponent(() => <PetsitterServiceadsView />),
                // },
                // {
                //   path: "services/ads/create",
                //   element: makeLazyComponent(() => <PetsitterServicesAdsCreate />),
                // },
                // {
                //   path: "services/ads/edit/:adId",
                //   element: <PetsitterServicesAdsCreate />,
                // },
              ],
            },
          ]
          : []),
        ...(hasPermission("Vendor Management", user)
          ? [
            {
              path: "product",
              children: [
                {
                  index: true,
                  path: ":id",
                  element: makeLazyComponent(() => <ProductList />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <ProductView />),
                },

                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <ProductEdit />),
                },
                {
                  path: "add/:id",
                  element: makeLazyComponent(() => <ProductEdit />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Category Management", user)
          ? [
            {
              path: "category",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <Category />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <AddEditCategory />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AddEditCategory />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <CategoryView />),
                },
                {
                  path: "add-subcategory/:categoryid",
                  element: makeLazyComponent(() => <AddEditSubCategory />),
                },
                {
                  path: "edit-subcategory/:categoryid/:id",
                  element: makeLazyComponent(() => <AddEditSubCategory />),
                },
                {
                  path: "viewsubcategory/:id",
                  element: makeLazyComponent(() => <ViewSubLastCategory />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Vendor Management", user)
          ? [
            {
              path: "ads",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <AdsList />),
                },
                {
                  path: ":vendor_id",
                  element: makeLazyComponent(() => <AdsList />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <AdsView />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AdsAddEdit />),
                },
                {
                  path: "add/:vendor_id",
                  element: makeLazyComponent(() => <AdsAddEdit />),
                },

                // {
                //   path: "edit",
                //   element: makeLazyComponent(() => <VendorEdit />),
                // },
                // {
                //   path: "add",
                //   element: makeLazyComponent(() => <VendorAdd />),
                // },
              ],
            },
          ]
          : []),
        ...(hasPermission("FAQ Management", user) ||
          hasPermission("About Us", user) ||
          hasPermission("Community Guidelines", user) ||
          hasPermission("Privacy Policy", user) ||
          hasPermission("Terms & Conditions", user) ||
          hasPermission("Event Guidelines", user) ||
          hasPermission("Refund Policies", user) ||
          hasPermission("Notification Management", user) ||
          hasPermission("Other CMS", user) ||
          hasPermission("Landing Page Management", user)
          ? [
            {
              path: "cms",
              children: [
                ...(hasPermission("FAQ Management", user)
                  ? [
                    {
                      path: "faq-management",
                      children: [
                        {
                          index: true,
                          element: makeLazyComponent(() => <FaqList />),
                        },
                        {
                          path: "add",
                          element: makeLazyComponent(() => <FaqAdd />),
                        },
                        {
                          path: "view/:id",
                          element: makeLazyComponent(() => <Faqview />),
                        },
                        {
                          path: "edit/:id",
                          element: makeLazyComponent(() => <FaqEdit />),
                        },
                      ],
                    },
                  ]
                  : []),
                ...(hasPermission("About Us", user)
                  ? [
                    {
                      path: "about-us",
                      children: [
                        // {
                        //   index: true,
                        //   element: makeLazyComponent(() => <AbtList />),
                        // },
                        {
                          index: true,
                          element: makeLazyComponent(() => <AbtView />),
                        },
                        {
                          path: "edit/:id",
                          element: makeLazyComponent(() => <AbtEdit />),
                        },
                        {
                          path: "view/:id",
                          element: makeLazyComponent(() => <AbtView />),
                        },
                      ],
                    },
                  ]
                  : []),
                ...(hasPermission("Community Guidelines", user)
                  ? [
                    {
                      path: "community",
                      children: [
                        {
                          index: true,
                          element: makeLazyComponent(() => <CommView />), // direct view dikhega
                        },
                        {
                          path: "edit/:id",
                          element: makeLazyComponent(() => <CommEdit />),
                        },
                      ],
                    },
                  ]
                  : []),
                ...(hasPermission("Privacy Policy", user)
                  ? [
                    {
                      path: "privacypolicy",
                      children: [
                        {
                          index: true,
                          element: makeLazyComponent(() => (
                            <PrivacypolicyList />
                          )), // direct view page dikhega
                        },
                        {
                          path: "view/:id",
                          element: makeLazyComponent(() => (
                            <PrivacypolicyView />
                          )),
                        },
                        {
                          path: "edit/:id",
                          element: makeLazyComponent(() => (
                            <PrivacypolicyEdit />
                          )),
                        },
                      ],
                    },
                  ]
                  : []),
                ...(hasPermission("Event Guidelines", user)
                  ? [
                    {
                      path: "eventguidelines",
                      children: [
                        // {
                        //   index: true,
                        //   element: makeLazyComponent(() => <EventGuidelinsList />),
                        // },
                        {
                          path: "edit/:id",
                          element: makeLazyComponent(() => (
                            <EventGuidelinsEDIT />
                          )),
                        },
                        {
                          index: true,
                          element: makeLazyComponent(() => (
                            <EventGuidelinsView />
                          )),
                        },
                      ],
                    },
                  ]
                  : []),
                ...(hasPermission("Refund Policies", user)
                  ? [
                    {
                      path: "refundpolicies",
                      children: [
                        {
                          // index: true,
                          element: makeLazyComponent(() => (
                            <RefundpoliciesList />
                          )),
                        },
                        {
                          path: "edit/:id",
                          element: makeLazyComponent(() => (
                            <RefundpoliciesEDIT />
                          )),
                        },
                        {
                          // path: "view/:id",
                          index: true,

                          element: makeLazyComponent(() => (
                            <RefundpoliciesView />
                          )),
                        },
                      ],
                    },
                  ]
                  : []),
                ...(hasPermission("Terms & Conditions", user)
                  ? [
                    {
                      path: "termsconditions",
                      children: [
                        {
                          index: true,
                          element: makeLazyComponent(() => (
                            <TermsConditionList />
                          )), // ✅ list ki jagah view
                        },
                        {
                          path: "view/:id",
                          element: makeLazyComponent(() => (
                            <TermsConditionView />
                          )),
                        },
                        {
                          path: "edit/:id",
                          element: makeLazyComponent(() => (
                            <TermsConditionEdit />
                          )),
                        },
                        // {
                        //   path: "view/:id",
                        //   element: makeLazyComponent(() => <TermsConditionView />),
                        // },
                      ],
                    },
                  ]
                  : []),
                ...(hasPermission("Notification Management", user)
                  ? [
                    {
                      path: "notification-templates",
                      children: [
                        {
                          index: true,
                          element: makeLazyComponent(() => (
                            <NotificationTemplateList />
                          )),
                        },
                        {
                          path: "add",
                          element: makeLazyComponent(() => (
                            <NotificationTemplateAddEdit />
                          )),
                        },
                        {
                          path: "view/:id",
                          element: makeLazyComponent(() => (
                            <NotificationTemplateView />
                          )),
                        },
                        {
                          path: "edit/:id",
                          element: makeLazyComponent(() => (
                            <NotificationTemplateAddEdit />
                          )),
                        },
                      ],
                    },
                  ]
                  : []),
                ...(hasPermission("Other CMS", user)
                  ? [
                    {
                      path: "other",
                      children: [
                        {
                          index: true,
                          element: makeLazyComponent(() => <CmsOtherList />),
                        },
                        {
                          path: "edit/:id",
                          element: makeLazyComponent(() => <CmsOtherAddEdit />),
                        },
                        {
                          path: "view/:id",
                          element: makeLazyComponent(() => <CmsOtherView />),
                        },
                      ],
                    },
                  ]
                  : []),
              ],
            },
          ]
          : []),
        ...(hasPermission("Landing Page Management", user)
          ? [
            {
              path: "landing-page",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <LandingPageManage />),
                },
              ],
            },
          ]
          : []),
      ],
    },

    {
      path: "*",
      element: <Navigate to={getFirstAvailableRoute(user) || "/dashboard"} />,
    },
  ];

  return useRoutes(routes);
};

export default MainRouting;
